import { render, staticRenderFns } from "./ModalRemision.vue?vue&type=template&id=3309138c&lang=pug&"
import script from "./ModalRemision.vue?vue&type=script&lang=js&"
export * from "./ModalRemision.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports